import en from "@/i18n/locales/en";
import nb from "@/i18n/locales/nb";
import zh from "@/i18n/locales/zh";
import ru from "@/i18n/locales/ru";
import th from "@/i18n/locales/th";
import se from "@/i18n/locales/se";
import enPages from "@/i18n/pages/en";
import nbPages from "@/i18n/pages/nb";
import zhPages from "@/i18n/pages/zh";
import ruPages from "@/i18n/pages/ru";
import thPages from "@/i18n/pages/th";
import sePages from "@/i18n/pages/se";
import enSupporter from "@/i18n/supporter/en";
import nbSupporter from "@/i18n/supporter/nb";
import zhSupporter from "@/i18n/supporter/zh";
import ruSupporter from "@/i18n/supporter/ru";
import thSupporter from "@/i18n/supporter/th";
import seSupporter from "@/i18n/supporter/se";
import enTrails from "@/i18n/trails/en";
import nbTrails from "@/i18n/trails/nb";
import zhTrails from "@/i18n/trails/zh";
import ruTrails from "@/i18n/trails/ru";
import thTrails from "@/i18n/trails/th";
import seTrails from "@/i18n/trails/se";
import enBusiness from "@/i18n/business/en";
import nbBusiness from "@/i18n/business/nb";
import zhBusiness from "@/i18n/business/zh";
import ruBusiness from "@/i18n/business/ru";
import thBusiness from "@/i18n/business/th";
import seBusiness from "@/i18n/business/se";
import enSignup from "@/i18n/signup/en";
import nbSignup from "@/i18n/signup/nb";
import zhSignup from "@/i18n/signup/zh";
import ruSignup from "@/i18n/signup/ru";
import thSignup from "@/i18n/signup/th";
import seSignup from "@/i18n/signup/se";
import enGetApp from "@/i18n/getapp/en";
import nbGetApp from "@/i18n/getapp/nb";
import zhGetApp from "@/i18n/getapp/zh";
import ruGetApp from "@/i18n/getapp/ru";
import thGetApp from "@/i18n/getapp/th";
import seGetApp from "@/i18n/getapp/se";
import enPeek from "@/i18n/peek/en";
import nbPeek from "@/i18n/peek/nb";
import zhPeek from "@/i18n/peek/zh";
import ruPeek from "@/i18n/peek/ru";
import thPeek from "@/i18n/peek/th";
import sePeek from "@/i18n/peek/se";
import enHosts from "@/i18n/hosts/en";
import nbHosts from "@/i18n/hosts/nb";
import zhHosts from "@/i18n/hosts/zh";
import ruHosts from "@/i18n/hosts/ru";
import thHosts from "@/i18n/hosts/th";
import seHosts from "@/i18n/hosts/se";

export const LANGS = [
  { code: "nb", label: "Norsk", html: "nb", locale: "nb-NO" },
  { code: "se", label: "Davvisámegiella", html: "se", locale: "se-NO" },
  { code: "en", label: "English", html: "en", locale: "en-GB" },
  { code: "zh", label: "中文", html: "zh-Hans", locale: "zh-CN" },
  { code: "ru", label: "Русский", html: "ru", locale: "ru-RU" },
  { code: "th", label: "ไทย", html: "th", locale: "th-TH" },
];

const build = (base, trails, pages, supporter, business, signup, getApp, peek, hosts) => ({
  ...base,
  trails,
  peek,
  pages: { ...pages, supporter, business, signup, getApp, hosts },
});

export const STRINGS = {
  nb: build(nb, nbTrails, nbPages, nbSupporter, nbBusiness, nbSignup, nbGetApp, nbPeek, nbHosts),
  se: build(se, seTrails, sePages, seSupporter, seBusiness, seSignup, seGetApp, sePeek, seHosts),
  en: build(en, enTrails, enPages, enSupporter, enBusiness, enSignup, enGetApp, enPeek, enHosts),
  zh: build(zh, zhTrails, zhPages, zhSupporter, zhBusiness, zhSignup, zhGetApp, zhPeek, zhHosts),
  ru: build(ru, ruTrails, ruPages, ruSupporter, ruBusiness, ruSignup, ruGetApp, ruPeek, ruHosts),
  th: build(th, thTrails, thPages, thSupporter, thBusiness, thSignup, thGetApp, thPeek, thHosts),
};
